import React from "react";
import { Routes, Route } from "react-router-dom";
import { useMyContext } from "src/hooks/context";

import { ConfigProvider } from "antd";
import mnMN from "antd/lib/locale/mn_MN";
import "src/index.css";
import "antd/dist/antd.min.css";
import "moment/locale/mn";

import Layout from "src/components/layout";
import Home from "src/pages/home";

const Router = () => {
  const { state } = useMyContext();

  return (
    <>
      {state?.loggedIn && (
        <ConfigProvider locale={mnMN}>
          <Layout>
            <Routes>
              <Route exact path="/" element={<Home />} />
            </Routes>
          </Layout>
        </ConfigProvider>
      )}
    </>
  );
};

export default React.memo(Router);
